import { ErrorBoundary } from "react-error-boundary";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BlockDatesTab } from "../calendar/BlockDatesTab";
import { PricingTab } from "../calendar/PricingTab";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import type { Property } from "@/types/property";

interface PropertyTabsProps {
  property: Property;
}

const ErrorFallback = () => (
  <Alert variant="destructive">
    <AlertTriangle className="h-4 w-4" />
    <AlertDescription>
      There was an error loading this content. Please try again later.
    </AlertDescription>
  </Alert>
);

export const PropertyTabs = ({ property }: PropertyTabsProps) => {
  return (
    <Tabs defaultValue="pricing" className="w-full flex-grow">
      <TabsList className="w-full">
        <TabsTrigger value="pricing" className="flex-1">Pricing</TabsTrigger>
        <TabsTrigger value="calendar" className="flex-1">Calendar</TabsTrigger>
        <TabsTrigger value="responses" className="flex-1">Responses</TabsTrigger>
      </TabsList>
      
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <TabsContent value="pricing">
          <PricingTab 
            propertyId={property.id} 
            existingBookings={property.bookings || []}
          />
        </TabsContent>
        <TabsContent value="calendar">
          <BlockDatesTab 
            propertyId={property.id} 
            existingBookings={property.bookings || []}
          />
        </TabsContent>
        <TabsContent value="responses">
          Automated responses coming soon...
        </TabsContent>
      </ErrorBoundary>
    </Tabs>
  );
};